<template>
    <div id="welcome" v-if='isADShow'>
            <div class="welcome_panel" v-if='isWelcoShow'>
                <div class="panel_main">
                  <!-- ./img/img_icon_1011.png -->
                    <img src="./img/img_icon_1011.png" class="close_btn" @click="popClose" />
                    <!-- ./img/header/icon_img1.png -->
                    <div class="panel_title">欢迎来到<img class="logo_img" src="@/views/objIcon/MJ.png">MJ 绘画官网</div>

                    <div class="panel_subtitle">为了让中国大陆用户操作更便捷，体验感更佳！</div>
                    <div class="panel_content">
                        <div class="panel_item play_video">
                            <div class="item_top">超过 99% 新用户观看了福利视频</div>
                            <div class="item_content" @click="showVideDialog">
                              <!-- ./img/img_icon_16.png -->
                                <img class="video_icon" src="./img/img_icon_16.png" alt="">
                                <!-- ./img/img_icon_02.gif -->
                                <div class="content_text"><span class="text_span">MJ 绘画创作新手教程<img class="hot_icon" src="./img/img_icon_02.gif" alt=""></span></div>
                                <div class="content_tips">新手如何一键创作高质量绘画？</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      <videoDialog ref="videoDialogPopup" v-show="isShowVideo" @popClose="popClose"></videoDialog>
    </div>
</template>
<script>
import videoDialog from "@/components/VideoDialogAd.vue"
export default {
    components:{videoDialog},
    data(){
        return{
            isShowVideo:false,
            docnum:0,
            todayText:'',
            today_doc_num:0,
            date:new Date(),
            month:new Date().getMonth()+1,
            day:new Date().getDate(),
            isWelcoShow:true
        }
    },
    methods:{
        show(){
            this.$refs.popupDialog.show();
        },
        getCloseData(){
          this.isWelcoShow = true
        },
    popClose(){
        // this.$refs.popupDialog.close();
        // this.isShow = false
        let tgad = this.getCache("tgad") || ""
        let adsid = this.getCache("site_id") || ""
        location.href = MAIN_URLROOT + "?adaid=" + AD_AID + "&tgad=" + tgad + "&adsid=" + adsid
    },
    installNow(){
        console.log("installNow deferredPrompt=", deferredPrompt)
        deferredPrompt.prompt()
        this.popClose();
        let user_id = localStorage.getItem("user_id")||0;
        deferredPrompt.userChoice.then(function(e) {
            if (e.outcome === 'dismissed'){
                // 不允许
                //埋点
                // zjzBrowseRecord({user_id:user_id, mod_code:"p003"})
            } else {
                // 允许
                //埋点
                // zjzBrowseRecord({user_id:user_id, mod_code:"p002"})
            }
        })
    },
    showVideDialog(){
      this.isWelcoShow = false
      // this.$store.commit('showVideoPop',true)
      this.$store.commit('videoPlayUrl','https://jindouyuan202105.oss-cn-beijing.aliyuncs.com/ad/huihuaxinshoujiaocheng.mp4')
      // setTimeout(() => {
      //     this.$refs.playVidRef.playVid()
      // });
      this.isShowVideo = true
      this.$refs.videoDialogPopup.playVideo()
    },
    
    getDat(){
        this.$http.get(`/front/suno/squre/index/`).then(res =>{
            if(res.status=='200'){
                this.docnum = res.data.total_num
                this.today_doc_num = res.data.today_doc_num

            }
        })
    }
    },
    mounted(){
        this.todayText = this.month + "月" + this.day + "日";
    },
    computed:{
        isADShow(){
            return this.$store.state.isADShow;
        },
        isLogin() {
            return this.$store.state.isLogin;
        }
    }
}


</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#welcome{
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    display: flex;
    align-items: center;
    justify-content: center;
}
    .welcome_panel{
        display: flex;
        font-size: 12px;
        color: #000;
        .panel_main{
            width: 320px;
            // height: 560px;
            position: relative;
            padding: 30px 20px;
            text-align: center;
            background-color: #fff;
            border-radius: 3px;
            .panel_title{
                font-size: 18px;
                line-height: 40px;
                .logo_img{
                    width: 26px;
                    margin: -3px 3px 0 5px;
                    vertical-align: middle;
                }
            }
            .panel_subtitle{
                font-size: 13px;
                line-height: 40px;
                color: #0000ff;
                // font-weight: bold;
            }
            .panel_content{
                padding-top: 10px;
                display: flex;
                .panel_item{
                    flex-grow: 1;
                    width: 0;
                    &.play_video{
                        margin-right: 12px;
                        .item_top{
                            border: 1px solid #ccc;
                            background-color: #f5f5f5;
                            line-height: 50px;
                            position: relative;
                            color: #999;
                            border-radius: 3px;
                            &::after{
                                content: "";
                                position: absolute;
                                display: block;
                                width: 14px;
                                height: 14px;
                                border: 1px solid #ccc;
                                border-top-color: transparent;
                                border-left-color: transparent;
                                left: 50%;
                                bottom: -7px;
                                box-sizing: border-box;
                                transform-origin: center;
                                transform: rotate(45deg);
                                background-color: #f5f5f5;
                            }
                        }
                        .item_content{
                            background-color: #f5f5f5;
                            padding-top: 50px;
                            .video_icon{
                                width: 36px;
                                display: block;
                                margin: 0 auto;
                                cursor: pointer;
                            }
                            .content_text{
                                line-height: 62px;
                                .text_span{
                                    color: #ec3b3b;
                                    position: relative;
                                    .hot_icon{
                                        position: absolute;
                                        top: -15px;
                                        right: -23px;
                                    }
                                }
                            }
                           
                            .content_tips{
                                color: #999;
                                line-height: 46px;
                            }
                        }
                    }
                    .item_top{
                        height: 52px;
                        margin-bottom: 11px;
                    }
                    .item_content{
                        height: 240px;
                        border-radius: 3px;
                        border: 1px solid #ccc;
                        position: relative;
                    }
                }
            }
            .close_btn{
                position: absolute;
                top: 12px;
                right: 12px;
                width: 14px;
                height: 14px;
                cursor: pointer;
            }
        }
    }
</style>